import { useMutation } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { apiClient } from 'src/services/api/client';
import { getApiErrorMessage } from 'src/services/api/utils';
import { LANDLORD_SELF_INVITE_PATH } from 'src/services/api/onboarding/invites/constants';

export const useResendInvite = (inviteId: number) => {
    const { addNotification } = useNotifications();

    return useMutation<
        void,
        IStandardErrorResponse
    >(
        async () => {
            await apiClient(`${LANDLORD_SELF_INVITE_PATH}/${inviteId}/resend`, {
                method: 'post',
            });
        }, {
            onSuccess: () => {
                addNotification('Invite sent', 'success');
            }, onError: (error) => {
                const errorMessage = getApiErrorMessage(error) || 'Failed to send invites';
                addNotification(errorMessage, 'error');
            }
        });
};
